import { render, staticRenderFns } from "./GlobalToast.vue?vue&type=template&id=74b567a3&scoped=true"
import script from "./GlobalToast.vue?vue&type=script&lang=js"
export * from "./GlobalToast.vue?vue&type=script&lang=js"
import style0 from "./GlobalToast.vue?vue&type=style&index=0&id=74b567a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b567a3",
  null
  
)

export default component.exports